import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="gkv-gpv-beitrag"
export default class extends Controller {
	static targets = ["intervall", "zusatzbeitragssatz", "beitraege"]

	connect() {}

	updateModus({ currentTarget }) {
		this.intervallTarget.classList.add("hidden")
		this.zusatzbeitragssatzTarget.classList.add("hidden")
		this.beitraegeTarget.classList.add("hidden")

		switch (currentTarget.value) {
			case "prozentual":
				this.zusatzbeitragssatzTarget.classList.remove("hidden")
				break
			case "familienversichert":
				break
			case "nominal":
				this.intervallTarget.classList.remove("hidden")
				this.beitraegeTarget.classList.remove("hidden")
				break
		}
	}
}
